import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1661313427494'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='17918'
    >
        <path
            d='M828.7 102.1H182.4c-36.6 0-66.3 29.7-66.3 66.3v699.2c0 36.6 29.7 66.3 66.3 66.3h646.3c36.6 0 66.3-29.7 66.3-66.3V168.4c0-36.5-29.8-66.3-66.3-66.3zM825 863.9H186.1V172.1H825v691.8z'
            p-id='17919'
            fill='currentColor'
        ></path>
        <path
            d='M425 381l95.4 87.4 184.7-169.1-47.3-51.6-137.4 125.8-95.4-87.4-119.1 109.1 47.3 51.6zM544.5 672.7h72.4v-40.2h-72.4v-23h78.8V568H470.8c2.3-5.4 4.4-10.7 6.1-16l1.6-5.1-42.9-11.1-1.5 4.4c-3.8 11.5-8.7 23-14.4 34-5.7 11.1-12.2 21.5-19.3 31-7 9.4-14.6 17.6-22.5 24.3l-5.3 4.5 6 3.6c2.6 1.5 5.6 3.6 9.1 6.1 3.5 2.5 7 5.2 10.3 7.8 3.4 2.7 6.1 5 8.2 6.8l3.5 3.1 3.3-3.3c2.5-2.5 5-5.1 7.4-7.9v54.2H377v41.4h123.7v58.8h43.8v-58.8h93.9v-41.4h-93.9v-31.7z m-43.8 31.7h-37.6v-31.7h37.6v31.7z m0-71.9h-66c5.2-7.1 10.2-14.8 15-23h51v23z'
            p-id='17920'
            fill='currentColor'
        ></path>
    </svg>
)

export const YearlyIcon = props => <Icon component={SVG} {...props} />
